import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  getSettingsViewActiveTab,
  settingsViewInit,
  settingsViewSetActiveTab,
} from '../settingsViewSlice';
import { RootState } from '../../../../store';
import { routingOnRouteToSettings } from 'src/app/store/routingSlice';
import { Routes, settingsRouteToTabMap } from 'src/routes';
import { PayloadAction } from '@reduxjs/toolkit';

type IN = ReturnType<typeof settingsViewInit>;
type OUT = ReturnType<typeof settingsViewSetActiveTab>;

export const SettingsViewOnRouteToSettings: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(routingOnRouteToSettings.match),
    withLatestFrom(state$),
    switchMap(([{ payload: path }, state]) => {
      if (!path) return [];

      const nextActions: PayloadAction<any, any>[] = [];
      const currActiveTab = getSettingsViewActiveTab(state);
      const nextActiveTab = settingsRouteToTabMap[path];

      if (currActiveTab !== nextActiveTab) {
        nextActions.push(settingsViewSetActiveTab(nextActiveTab));
      }

      return nextActions;
    }),
  );
